<template>
  <div >
    <v-navigation-drawer class="no-print" v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              @click="()=>{}"
              :to="child.page"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" @click="()=>{}" :to="item.page">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar  class="no-print"  :clipped-left="$vuetify.breakpoint.lgAndUp" app color="orange darken-3" dark>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">SISTEMA DE PEDIDOS</span>
      </v-toolbar-title>

      <div class="flex-grow-1"></div>
     
      <v-btn icon @click="logout()">
        <v-icon>power_settings_new</v-icon>
      </v-btn>
      <v-btn icon large @click="dashboard()">
        <v-avatar size="32px" item>
          <v-img src="./infous.png" alt="Vuetify"></v-img>
        </v-avatar>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data() {
    return {
      dialog: false,
      drawer: null,
      user: null,
      items: [],
    };
  },
  created() {
    this.sessionVerify();
  },
  methods: {
    selectNav() {
      let level = localStorage.getItem("user_level");

      if (level == 1) {
        this.items = [
          { icon: "dashboard", text: "Painel", page: "/home" },
          { icon: "receipt", text: "Pedidos", page: "/sales_orders" },
          { icon: "contacts", text: "Clientes", page: "/customers" },
          { icon: "category", text: "Produtos", page: "/products/plates" },
          // { icon: "local_bar", text: "Bebidas", page: "/products/drinks" },
          // { icon: "cake", text: "Sobremesa", page: "/products/dessert" },
          {
            icon: "payment",
            text: "Forma de Pagamentos",
            page: "/type_payments",
          },
          { icon: "group", text: "Usuários", page: "/users" },
        ];
      }


      if(level == 2){
        this.items = [
          { icon: "dashboard", text: "Painel", page: "/home" },
          { icon: "receipt", text: "Pedidos", page: "/sales_orders" },
          { icon: "contacts", text: "Clientes", page: "/customers" },
        ];
      }


      if(level == 3){
        this.items = [
          { icon: "dashboard", text: "Painel", page: "/home" },
        ];
      }

      
    },
    dashboard() {
      this.$router.replace("/home");
    },
    async sessionVerify() {
     
      let token = await localStorage.getItem("api_token");
      if (token) {
        this.getSession(token)
          .then((response) => {
            //console.log("RESPONSE",response);
            if (!response) {
              this.$router.replace("/login");
            }
            this.selectNav();
          })
          .catch((e) => {
            // console.log(e);
            return e;
          });
      } else {
        this.$router.replace("/login");
      }
    },
    async getSession(token) {
      let url = "users/session";
      this.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
      var error = true;

      try {
        await this.$http
          .get(url)
          .then((response) => response.data)
          .then((user) => {
            this.setUser(user);
            this.user = user;
            error = false;
          });
      } catch (e) {
        this.logout();
        return e;
      }

      if (!error) {
        return true;
      } else {
        return false;
      }
    },
    setUser(user) {
      localStorage.setItem("user_id", user.id);
      localStorage.setItem("user_name", user.name);
      localStorage.setItem("user_email", user.email);
      localStorage.setItem("user_level", user.level);
      localStorage.setItem("user_created_at", user.created_at);
    },
    removeUser() {
      localStorage.removeItem("user_id");
      localStorage.removeItem("user_name");
      localStorage.removeItem("user_email");
      localStorage.removeItem("user_created_at");
      localStorage.removeItem("api_token");
      this.$router.replace("/login");
    },
    logout() {
      this.removeUser();
    },
  },
};
</script>